module.exports = __webpack_public_path__ + "media/img/illustrations/icons/notifications-active-235ea465456a2019005c1e57e127cdbf.svg";